var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.imageUrl&&_vm.imageUrl.length>0)?_c('div',{staticClass:"home_top_pic"},[(_vm.link&&_vm.link.length>0)?_c('a',{staticClass:"external",attrs:{"target":"_blank","href":_vm.link}},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.imageUrl}})]):_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.imageUrl}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }